const useAnimate = ({ keyframes, duration = '.5s', timing = 'ease', originX = 'center', originY, fill = 'forwards', }) => {
    const transformOrigin = [originX, originY].join(' ');
    const animation = [keyframes, duration, timing, fill].join(' ');
    return {
        animation: {
            animation,
            transformOrigin,
        }
    };
};
export default useAnimate;
